import { render, staticRenderFns } from "./GiftIdeas.vue?vue&type=template&id=56af923c&scoped=true&"
import script from "./GiftIdeas.ts?vue&type=script&lang=ts&"
export * from "./GiftIdeas.ts?vue&type=script&lang=ts&"
import style0 from "./GiftIdeas.vue?vue&type=style&index=0&id=56af923c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56af923c",
  null
  
)

export default component.exports